"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var App_vue_1 = __importDefault(require("./App.vue"));
var vue_i18n_1 = __importDefault(require("vue-i18n"));
exports.default = {
    initComponent: function (options) {
        var _a, _b;
        var elementSelector = '#app-collection-index';
        var element = document.querySelector(elementSelector);
        if (element === null) {
            return;
        }
        vue_1.default.config.productionTip = options.vueProductionTip;
        vue_1.default.use(vue_i18n_1.default);
        var i18n = new vue_i18n_1.default(options.vueI18n);
        // TODO: Replace with 'vue-plugin-axios'
        vue_1.default.prototype.$http = options.axios;
        var vm = new App_vue_1.default({
            i18n: i18n,
            propsData: {
                scrollOffset: (_a = options.scrollOffset) !== null && _a !== void 0 ? _a : 0,
                initialSearchTerm: (_b = element.dataset.searchTerm) !== null && _b !== void 0 ? _b : '',
            }
        });
        vm.$mount(elementSelector);
    }
};
